import {formatToYYYYMMDD} from './DateFunctions'

export const buildGetWebformRoutingsOrderNum = (orderNum) => { 
 
    const xml = `
        <GetWebformRoutingsOrderNumRQ xsi:schemaLocation="NetSemanticsSA_CRM GetWebformRoutingsOrderNumRQ.xsd" xmlns="NetSemanticsSA_CRM" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
            <UserProfile AccountID="${localStorage.getItem('AccountID')}" isAdmin="${localStorage.getItem('isAdmin') }" /> 
            <OrderNum number="${orderNum}" />
        </GetWebformRoutingsOrderNumRQ>
        `;
        return xml.trim(); 
    };

export const buildGetWebformRoutings = (selectedDatefrom,selectedDateto,vehicleid,flight) => { 
 
    const xml = `
        <GetWebformRoutingsRQ xsi:schemaLocation="NetSemanticsSA_CRM GetWebformRoutingsRQ.xsd" xmlns="NetSemanticsSA_CRM" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
            <UserProfile AccountID="${localStorage.getItem('AccountID')}" isAdmin="${localStorage.getItem('isAdmin') }" /> 
            <Dates DateFrom="${formatToYYYYMMDD(selectedDatefrom)}" DateTo="${formatToYYYYMMDD(selectedDateto)}" /> 
            <Vehicle id="${vehicleid}" />
            <Flight number="${flight}" />
        </GetWebformRoutingsRQ>
        `;
        return xml.trim(); 
    };

export const buildgetVehicles = () => { 
    const xml = `
        <GetUserPlatesRQ xsi:schemaLocation="NetSemanticsSA_CRM GetUserPlatesRQ.xsd" xmlns="NetSemanticsSA_CRM" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
            <UserProfile AccountID="${localStorage.getItem('AccountID')}" isAdmin="${localStorage.getItem('isAdmin') }" /> 
        </GetUserPlatesRQ>
        `;
        return xml.trim(); 
    };

export const buildUpdateRoutingPlateRQ = (rooid,plate) => { 
const xml = `
    <UpdateRoutingPlateRQ xsi:schemaLocation="NetSemanticsSA_CRM UpdateRoutingPlateRQ.xsd" xmlns="NetSemanticsSA_CRM" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
        <RootingPlate RooID="${rooid}" Plate="${plate}" /> 
    </UpdateRoutingPlateRQ>
    `;
    return xml.trim(); 
};

export const buildInsertRoutingPlateRQ = (rooid,plate) => { 
const xml = `
    <InsertRoutingPlateRQ xsi:schemaLocation="NetSemanticsSA_CRM InsertRoutingPlateRQ.xsd" xmlns="NetSemanticsSA_CRM" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
        <RootingPlate RooID="${rooid}" Plate="${plate}" Supplier="${localStorage.getItem('AccountID')}" isAdmin="${localStorage.getItem('isAdmin')}" /> 
    </InsertRoutingPlateRQ>
    `;
    return xml.trim(); 
}; 
 
export const buildGetWebformRoutingDetails = (id) => { 
const xml = `
    <GetWebformRoutingDetailsRQ xsi:schemaLocation="NetSemanticsSA_CRM GetWebformRoutingDetailsRQ.xsd" xmlns="NetSemanticsSA_CRM" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">
        <Rooting RooID="${id}" /> 
    </GetWebformRoutingDetailsRQ>
    `;
    return xml.trim(); 
};